import { markSessionActive } from './refreshService';
import { axiosInstance } from './axiosConfig';
import { rootInstance } from './axiosConfig';
import { AxiosResponse } from 'axios';
import { handleRequestWithAuth } from './landingrefreshService';

const API_URL_LOGIN = 'login/';
const API_URL_LOGOUT = 'logout/';
const API_URL_REGISTER = 'register/';

export interface User {
    perfil_publico?: boolean;
    id: number;
    email: string;
    first_name: string;
    last_name: string;
    role: string;
    user_level_id: number | null;
    perfil: 'cliente' | 'personal' | 'administrador';
    es_domiciliado?: boolean;
    domiciliacion_empresa?: string | null;
    tiene_servicio_correspondencia?: boolean;
    tiene_correspondencia_habilitada?: boolean;
    telefono?: string;
    ci_nit?: string;
    codigo_tipo_documento_identidad_sin?: number;
    complemento?: string;
    especialidad?: string;
    cargo?: string;
    foto_url?: string | null;
    personal_id?: number;
    cliente_id?: number;
    username?: string;
}

export interface LoginData {
    email: string;
    password: string;
}

export const login = async (formData: LoginData): Promise<AxiosResponse<any>> => {
    try {
        const response = await axiosInstance.post(API_URL_LOGIN, {
            email: formData.email.trim().toLowerCase(),
            password: formData.password,
        });
        if (!response.data?.requires_2fa) markSessionActive();
        /* Browser diagnostics omitted. */
        return response;
    } catch (error: any) {
        throw new Error(error.response?.data?.detail || 'Error de conexión con el servidor');
    }
};


export const logout = async () => {
    await axiosInstance.post(API_URL_LOGOUT, {}, {
        headers: { 'Content-Type': 'application/json' },
    });
};

export const registerUser = async (formData: {
    first_name: string;
    last_name: string;
    email: string;
    password: string;
    tipo_nivel_usuario?: number;
    telefono?: string;
    ci_nit?: string;
    codigo_tipo_documento_identidad_sin?: number;
    complemento?: string;
    especialidad?: string;
}) => {
    try {
        const response = await axiosInstance.post(API_URL_REGISTER, formData, {
            headers: { 'Content-Type': 'application/json' },
        });
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw error;
        }
        throw new Error('Error de conexión: Verifica que el servidor esté activo');
    }
};





// Obtener usuario actual
export const fetchCurrentUser = async (): Promise<User> => {
    return handleRequestWithAuth(async () => {
        const response = await rootInstance.get('/api/me');
        markSessionActive();
        return response.data;
    });
};

